// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2DtRt","col":"CardReaderDesc_col__2AsXc","label":"CardReaderDesc_label__3s_RK"};